export const AUTH_GATEWAY_URI = process.env.REACT_APP_AUTH_GATEWAY_URI!;
export const AUTH_LOGOUT_URI = process.env.REACT_APP_AUTH_LOGOUT_URI!;
export const AUTH_REFRESH_URI = `${
  process.env.REACT_APP_CONNECT_AUTH_BE_URI! || process.env.REACT_APP_CONNECT_BE_URI!
}/auth-srvc/auth/refresh`;

export const UNLEASH_ENV = process.env.REACT_APP_UNLEASH_ENV!;
export const UNLEASH_CLIENT_KEY = process.env.REACT_APP_UNLEASH_CLIENT_KEY!;
export const UNLEASH_PROXY_URI = process.env.REACT_APP_UNLEASH_PROXY_URI!;

export const GTM_ID = process.env.REACT_APP_GTM_ID!;

export const CONNECT_BE_URI = process.env.REACT_APP_CONNECT_BE_URI!;
